// Mock data for Syncore LLC Digital Agency

export const heroSlides = [
  {
    id: 1,
    title: "Web Development Excellence",
    description: "Building scalable, high-performance web applications",
    bgColor: "#470024",
    textColor: "#ffd1e7",
    image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1200&h=800&fit=crop",
    tags: ["Web Development", "UI/UX Design"]
  },
  {
    id: 2,
    title: "Blockchain Innovation",
    description: "Next-generation blockchain solutions for enterprise",
    bgColor: "#1f47e6",
    textColor: "#b7fbff",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=1200&h=800&fit=crop",
    tags: ["Blockchain", "Custom Software"]
  },
  {
    id: 3,
    title: "Mobile-First Solutions",
    description: "Native and cross-platform mobile applications",
    bgColor: "#808080",
    textColor: "#000000",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=1200&h=800&fit=crop",
    tags: ["Mobile App", "Cloud Solutions"]
  },
  {
    id: 4,
    title: "3D Animation & Design",
    description: "Creating immersive visual experiences",
    bgColor: "#a1a500",
    textColor: "#f6fd87",
    image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=1200&h=800&fit=crop",
    tags: ["3D Animation", "Creative Design"]
  }
];

export const services = [
  {
    id: 1,
    title: "Web Development",
    description: "Build powerful, scalable websites and web applications using modern technologies like React, Node.js, and cloud infrastructure. From landing pages to complex platforms.",
    bgColor: "#ffd1e7",
    icon: "Code",
    tags: ["React", "Node.js", "FastAPI"]
  },
  {
    id: 2,
    title: "UI/UX Design",
    description: "Create intuitive, beautiful interfaces that users love. We focus on user research, wireframing, prototyping, and delivering pixel-perfect designs that convert.",
    bgColor: "#d987ff",
    icon: "Palette",
    tags: ["Figma", "Design Systems", "Prototyping"]
  },
  {
    id: 3,
    title: "Blockchain Development",
    description: "Develop secure smart contracts, NFT marketplaces, and decentralized applications on Ethereum, Solana, and other blockchain networks.",
    bgColor: "#88a2ff",
    icon: "Box",
    tags: ["Ethereum", "Solidity", "Web3"]
  },
  {
    id: 4,
    title: "E-Commerce Development",
    description: "Launch your online store with secure payment processing, inventory management, customer analytics, and seamless shopping experiences.",
    bgColor: "#f6fd87",
    icon: "ShoppingCart",
    tags: ["Stripe", "Payment", "Analytics"]
  },
  {
    id: 5,
    title: "Custom Software Development",
    description: "Build bespoke software solutions tailored to your business processes. Enterprise-grade applications with scalable architecture and robust security.",
    bgColor: "#78d692",
    icon: "Cpu",
    tags: ["Custom", "Enterprise", "Scalable"]
  },
  {
    id: 6,
    title: "Mobile App Development",
    description: "Native iOS and Android apps or cross-platform solutions with React Native and Flutter. Beautiful, performant apps your users will love.",
    bgColor: "#b6cbcb",
    icon: "Smartphone",
    tags: ["React Native", "Flutter", "Swift"]
  },
  {
    id: 7,
    title: "3D Animation",
    description: "Bring your products to life with stunning 3D animations, product visualizations, and interactive 3D experiences for web and mobile.",
    bgColor: "#ff965a",
    icon: "Box",
    tags: ["Blender", "Three.js", "WebGL"]
  },
  {
    id: 8,
    title: "Cloud Solutions",
    description: "Deploy and scale your applications on AWS, Azure, or Google Cloud. DevOps, CI/CD pipelines, and infrastructure management.",
    bgColor: "#ff84e4",
    icon: "Cloud",
    tags: ["AWS", "Azure", "Docker"]
  },
  {
    id: 9,
    title: "Digital Marketing",
    description: "Grow your business with SEO, social media marketing, content strategy, and paid advertising campaigns that deliver measurable ROI.",
    bgColor: "#ffe03d",
    icon: "TrendingUp",
    tags: ["SEO", "Social Media", "Analytics"]
  },
  {
    id: 10,
    title: "Creative Copywriting",
    description: "Compelling copy that tells your brand story, engages your audience, and drives conversions. From website content to ad campaigns.",
    bgColor: "#b7fbff",
    icon: "PenTool",
    tags: ["Content", "Branding", "Storytelling"]
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: "$2,999",
    period: "per project",
    description: "Perfect for small businesses and startups looking to establish their digital presence",
    features: [
      "5-page responsive website",
      "Mobile-optimized design",
      "Basic SEO setup",
      "Contact form integration",
      "2 rounds of revisions",
      "30-day support",
      "Basic analytics setup"
    ],
    color: "#ffd1e7",
    popular: false
  },
  {
    id: 2,
    name: "Professional",
    price: "$7,999",
    period: "per project",
    description: "Ideal for growing businesses that need advanced features and functionality",
    features: [
      "15-page responsive website",
      "Custom UI/UX design",
      "Advanced SEO optimization",
      "CMS integration",
      "E-commerce functionality",
      "5 rounds of revisions",
      "90-day support",
      "Advanced analytics & reporting",
      "API integrations"
    ],
    color: "#d987ff",
    popular: true
  },
  {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    period: "pricing",
    description: "Comprehensive solutions for large-scale projects with complex requirements",
    features: [
      "Unlimited pages",
      "Bespoke design system",
      "Enterprise-grade security",
      "Custom integrations",
      "Blockchain solutions",
      "Unlimited revisions",
      "12-month support",
      "Dedicated project manager",
      "Priority support",
      "Ongoing maintenance"
    ],
    color: "#88a2ff",
    popular: false
  }
];

export const servicePricing = {
  combo: [
    {
      id: 1,
      name: "Starter Bundle",
      price: "$4,999",
      period: "one-time",
      description: "Perfect package for new businesses getting started",
      features: [
        "5-page website design & development",
        "Basic logo design",
        "Social media setup (2 platforms)",
        "Basic SEO",
        "1-month support"
      ],
      color: "#ffd1e7",
      popular: false
    },
    {
      id: 2,
      name: "Growth Bundle",
      price: "$12,999",
      period: "one-time",
      description: "Complete solution for growing businesses",
      features: [
        "15-page website + mobile app",
        "Complete branding package",
        "Social media management (3 months)",
        "Advanced SEO & content",
        "E-commerce integration",
        "3-month support"
      ],
      color: "#d987ff",
      popular: true
    },
    {
      id: 3,
      name: "Enterprise Bundle",
      price: "$35,000+",
      period: "custom",
      description: "Full-scale digital transformation",
      features: [
        "Custom web + mobile applications",
        "Complete design system",
        "Cloud infrastructure",
        "Marketing automation",
        "Team training",
        "12-month support"
      ],
      color: "#88a2ff",
      popular: false
    }
  ],
  webDevelopment: [
    {
      id: 1,
      name: "Landing Page",
      price: "$1,499",
      period: "one-time",
      description: "Single page website perfect for campaigns",
      features: [
        "Custom single-page design",
        "Responsive & mobile-friendly",
        "Contact form integration",
        "Basic SEO",
        "2 weeks delivery"
      ],
      color: "#ffd1e7",
      popular: false
    },
    {
      id: 2,
      name: "Business Website",
      price: "$3,999",
      period: "one-time",
      description: "Professional multi-page website",
      features: [
        "Up to 10 pages",
        "Custom design & animations",
        "CMS integration",
        "SEO optimization",
        "Contact & inquiry forms",
        "4 weeks delivery",
        "2-month support"
      ],
      color: "#d987ff",
      popular: true
    },
    {
      id: 3,
      name: "Web Application",
      price: "$12,000+",
      period: "custom",
      description: "Complex web app with backend",
      features: [
        "Custom functionality",
        "Database & API development",
        "User authentication",
        "Admin dashboard",
        "Cloud deployment",
        "3-month support"
      ],
      color: "#88a2ff",
      popular: false
    }
  ],
  uiuxDesign: [
    {
      id: 1,
      name: "Basic Design",
      price: "$1,999",
      period: "per project",
      description: "Essential UI/UX for small projects",
      features: [
        "5 screen designs",
        "Mobile & desktop layouts",
        "Basic style guide",
        "Clickable prototype",
        "2 revision rounds"
      ],
      color: "#ffd1e7",
      popular: false
    },
    {
      id: 2,
      name: "Professional Design",
      price: "$4,999",
      period: "per project",
      description: "Complete design package",
      features: [
        "15+ screen designs",
        "Design system & components",
        "Interactive prototypes",
        "User flow documentation",
        "Usability testing",
        "5 revision rounds"
      ],
      color: "#d987ff",
      popular: true
    },
    {
      id: 3,
      name: "Enterprise Design",
      price: "$15,000+",
      period: "custom",
      description: "Large-scale product design",
      features: [
        "Complete design system",
        "Unlimited screens",
        "Advanced prototypes",
        "User research included",
        "Accessibility compliance",
        "Ongoing support"
      ],
      color: "#88a2ff",
      popular: false
    }
  ],
  blockchain: [
    {
      id: 1,
      name: "Smart Contract",
      price: "$7,500",
      period: "per contract",
      description: "Single smart contract development",
      features: [
        "Smart contract coding",
        "Security audit",
        "Test deployment",
        "Documentation",
        "1-month support"
      ],
      color: "#ffd1e7",
      popular: false
    },
    {
      id: 2,
      name: "DApp Platform",
      price: "$22,000",
      period: "per project",
      description: "Complete decentralized app",
      features: [
        "Frontend interface",
        "Multiple smart contracts",
        "Web3 integration",
        "Wallet connection",
        "Security audit",
        "Mainnet deployment",
        "3-month support"
      ],
      color: "#d987ff",
      popular: true
    },
    {
      id: 3,
      name: "Enterprise Blockchain",
      price: "$75,000+",
      period: "custom",
      description: "Full blockchain solution",
      features: [
        "Custom blockchain network",
        "Complex contracts ecosystem",
        "Enterprise integration",
        "Multi-chain support",
        "Team training",
        "12-month support"
      ],
      color: "#88a2ff",
      popular: false
    }
  ],
  mobileApp: [
    {
      id: 1,
      name: "Simple App",
      price: "$5,999",
      period: "per platform",
      description: "iOS or Android app",
      features: [
        "Native or cross-platform",
        "Up to 8 screens",
        "Push notifications",
        "Basic analytics",
        "App store submission",
        "2-month support"
      ],
      color: "#ffd1e7",
      popular: false
    },
    {
      id: 2,
      name: "Full-Featured App",
      price: "$14,999",
      period: "both platforms",
      description: "iOS & Android app",
      features: [
        "Cross-platform development",
        "15+ screens",
        "Backend API integration",
        "User authentication",
        "Push notifications & analytics",
        "Both stores submission",
        "3-month support"
      ],
      color: "#d987ff",
      popular: true
    },
    {
      id: 3,
      name: "Complex App",
      price: "$35,000+",
      period: "custom",
      description: "Advanced mobile platform",
      features: [
        "Native iOS & Android",
        "Custom backend",
        "Advanced features",
        "Offline mode",
        "Enterprise security",
        "6-month support"
      ],
      color: "#88a2ff",
      popular: false
    }
  ],
  digitalMarketing: [
    {
      id: 1,
      name: "Basic Marketing",
      price: "$999",
      period: "per month",
      description: "Essential marketing for startups",
      features: [
        "Social media (2 platforms)",
        "8 posts per month",
        "Basic SEO",
        "Monthly report",
        "Email support"
      ],
      color: "#ffd1e7",
      popular: false
    },
    {
      id: 2,
      name: "Growth Marketing",
      price: "$2,999",
      period: "per month",
      description: "Comprehensive marketing",
      features: [
        "Social media (4 platforms)",
        "20 posts per month",
        "SEO & content marketing",
        "Paid ads ($2k budget included)",
        "Email campaigns",
        "Weekly reports"
      ],
      color: "#d987ff",
      popular: true
    },
    {
      id: 3,
      name: "Enterprise Marketing",
      price: "$7,500+",
      period: "per month",
      description: "Full-service marketing",
      features: [
        "Multi-channel campaigns",
        "Unlimited content",
        "Advanced analytics",
        "Influencer partnerships",
        "PR & media outreach",
        "Dedicated team"
      ],
      color: "#88a2ff",
      popular: false
    }
  ]
};

export const blogPosts = [
  {
    id: 1,
    title: "The Future of Web Development in 2025",
    excerpt: "Explore the latest trends and technologies shaping the future of web development.",
    date: "2025-01-15",
    author: "Sarah Chen",
    category: "Web Development",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?w=800&h=600&fit=crop"
  },
  {
    id: 2,
    title: "Building Scalable Blockchain Applications",
    excerpt: "Best practices for developing enterprise-grade blockchain solutions.",
    date: "2025-01-10",
    author: "Michael Torres",
    category: "Blockchain",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=800&h=600&fit=crop"
  },
  {
    id: 3,
    title: "UI/UX Design Principles That Convert",
    excerpt: "How to create user experiences that drive engagement and conversions.",
    date: "2025-01-05",
    author: "Emily Rodriguez",
    category: "Design",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?w=800&h=600&fit=crop"
  },
  {
    id: 4,
    title: "Cloud Architecture for Modern Apps",
    excerpt: "Designing cloud-native applications for maximum scalability and reliability.",
    date: "2024-12-28",
    author: "David Kim",
    category: "Cloud",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=600&fit=crop"
  },
  {
    id: 5,
    title: "Mobile-First Development Strategy",
    excerpt: "Why mobile-first approach is crucial for modern application development.",
    date: "2024-12-20",
    author: "Lisa Patel",
    category: "Mobile",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&h=600&fit=crop"
  },
  {
    id: 6,
    title: "Digital Marketing Trends for 2025",
    excerpt: "Stay ahead with these emerging digital marketing strategies and tactics.",
    date: "2024-12-15",
    author: "James Wilson",
    category: "Marketing",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Alex Morgan",
    role: "CEO & Founder",
    bio: "15+ years of experience in software development and digital transformation.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Sarah Chen",
    role: "CTO",
    bio: "Expert in cloud architecture and scalable system design.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "Michael Torres",
    role: "Head of Blockchain",
    bio: "Pioneer in blockchain technology with 10+ successful projects.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop"
  },
  {
    id: 4,
    name: "Emily Rodriguez",
    role: "Lead Designer",
    bio: "Creative designer specializing in user experience and branding.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop"
  },
  {
    id: 5,
    name: "David Kim",
    role: "DevOps Manager",
    bio: "Cloud infrastructure specialist with expertise in AWS and Azure.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop"
  },
  {
    id: 6,
    name: "Lisa Patel",
    role: "Marketing Director",
    bio: "Digital marketing strategist with proven track record in growth.",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop"
  }
];

export const companyTimeline = [
  {
    year: "2010",
    title: "The Beginning",
    description: "Founded by three passionate developers with a vision to transform digital experiences"
  },
  {
    year: "2013",
    title: "First Major Client",
    description: "Landed enterprise contract with Fortune 500 company, marking our entry into large-scale projects"
  },
  {
    year: "2016",
    title: "Blockchain Pioneer",
    description: "Launched dedicated blockchain division, becoming early adopters in Web3 technology"
  },
  {
    year: "2019",
    title: "International Expansion",
    description: "Opened offices in three continents, serving clients globally with 24/7 support"
  },
  {
    year: "2022",
    title: "Industry Recognition",
    description: "Won 'Best Digital Agency' award and featured in top technology publications"
  },
  {
    year: "2025",
    title: "AI Integration",
    description: "Leading the charge in AI-powered solutions and next-generation digital experiences"
  }
];

export const stats = [
  { label: "Projects Delivered", value: "250+" },
  { label: "Happy Clients", value: "180+" },
  { label: "Team Members", value: "50+" },
  { label: "Years Experience", value: "15+" }
];

export const testimonials = [
  {
    id: 1,
    name: "Jennifer Martinez",
    role: "CEO, TechStart Inc",
    content: "Syncore transformed our digital presence completely. Their team's creativity and technical expertise exceeded our expectations.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Robert Chen",
    role: "Founder, BlockChain Ventures",
    content: "The blockchain solution they built for us is secure, scalable, and exactly what we needed. Highly recommended!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "Amanda Foster",
    role: "Marketing Director, E-Shop Plus",
    content: "Our e-commerce platform has seen a 300% increase in conversions since the redesign. Outstanding work!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop"
  }
];


// Portfolio Projects by Service
export const portfolioProjects = {
  'Web Development': [
    {
      id: 1,
      title: 'FinTech Dashboard Platform',
      description: 'A comprehensive financial analytics dashboard built with React and FastAPI, processing millions of transactions daily.',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop',
      tags: ['React', 'FastAPI', 'PostgreSQL', 'Real-time Analytics'],
      metrics: { users: '50K+', uptime: '99.9%', speed: '< 2s load' }
    },
    {
      id: 2,
      title: 'SaaS Marketplace Platform',
      description: 'Multi-vendor marketplace with advanced search, payment integration, and vendor management.',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop',
      tags: ['Next.js', 'Stripe', 'MongoDB', 'AWS'],
      metrics: { vendors: '500+', transactions: '$2M+', rating: '4.8/5' }
    },
    {
      id: 3,
      title: 'Healthcare Portal',
      description: 'HIPAA-compliant patient management system with telemedicine capabilities.',
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop',
      tags: ['React', 'Node.js', 'WebRTC', 'Security'],
      metrics: { patients: '10K+', doctors: '200+', appointments: '5K/month' }
    }
  ],
  'Mobile App Development': [
    {
      id: 1,
      title: 'Fitness Tracking App',
      description: 'Cross-platform fitness app with AI-powered workout recommendations and social features.',
      image: 'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=800&h=600&fit=crop',
      tags: ['React Native', 'TensorFlow', 'Firebase', 'HealthKit'],
      metrics: { downloads: '100K+', rating: '4.7/5', retention: '65%' }
    },
    {
      id: 2,
      title: 'Food Delivery Platform',
      description: 'Complete food ordering ecosystem with real-time tracking and payment integration.',
      image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800&h=600&fit=crop',
      tags: ['Flutter', 'Google Maps', 'Stripe', 'Push Notifications'],
      metrics: { restaurants: '1K+', orders: '50K/month', avgTime: '28 mins' }
    },
    {
      id: 3,
      title: 'Banking Mobile App',
      description: 'Secure mobile banking solution with biometric authentication and instant transfers.',
      image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&h=600&fit=crop',
      tags: ['Swift', 'Kotlin', 'Face ID', 'Encryption'],
      metrics: { users: '250K+', transactions: '$50M+', security: 'Bank-grade' }
    }
  ],
  'UI/UX Design': [
    {
      id: 1,
      title: 'E-Learning Platform Redesign',
      description: 'Complete UX overhaul resulting in 40% increase in course completion rates.',
      image: 'https://images.unsplash.com/photo-1587440871875-191322ee64b0?w=800&h=600&fit=crop',
      tags: ['Figma', 'User Research', 'Prototyping', 'A/B Testing'],
      metrics: { completion: '+40%', engagement: '+65%', nps: '72' }
    },
    {
      id: 2,
      title: 'Travel Booking Experience',
      description: 'Intuitive booking flow design reducing cart abandonment by 35%.',
      image: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=800&h=600&fit=crop',
      tags: ['Sketch', 'InVision', 'User Testing', 'Accessibility'],
      metrics: { conversion: '+35%', time: '-45%', satisfaction: '4.6/5' }
    },
    {
      id: 3,
      title: 'Enterprise Dashboard UI',
      description: 'Data-rich dashboard design with customizable widgets and dark mode.',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop',
      tags: ['Adobe XD', 'Design System', 'Data Viz', 'Responsive'],
      metrics: { efficiency: '+50%', adoption: '95%', support: '-30%' }
    }
  ],
  'Digital Marketing': [
    {
      id: 1,
      title: 'SaaS Growth Campaign',
      description: 'Multi-channel marketing campaign generating 300% ROI in 6 months.',
      image: 'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=800&h=600&fit=crop',
      tags: ['SEO', 'Content Marketing', 'PPC', 'Email Automation'],
      metrics: { leads: '+450%', roi: '300%', cac: '-40%' }
    },
    {
      id: 2,
      title: 'E-Commerce Social Strategy',
      description: 'Instagram and TikTok campaign driving $500K in direct sales.',
      image: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=800&h=600&fit=crop',
      tags: ['Social Media', 'Influencer Marketing', 'Content Creation'],
      metrics: { reach: '2M+', sales: '$500K', engagement: '8.5%' }
    },
    {
      id: 3,
      title: 'Local Business SEO',
      description: 'Local SEO strategy increasing organic traffic by 250% in 4 months.',
      image: 'https://images.unsplash.com/photo-1562577309-4932fdd64cd1?w=800&h=600&fit=crop',
      tags: ['Local SEO', 'Google My Business', 'Link Building'],
      metrics: { traffic: '+250%', rankings: 'Top 3', calls: '+180%' }
    }
  ],
  'E-Commerce Development': [
    {
      id: 1,
      title: 'Fashion Retail Platform',
      description: 'Headless e-commerce solution with AR try-on feature and subscription model.',
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&h=600&fit=crop',
      tags: ['Shopify Plus', 'AR.js', 'Stripe', 'Klaviyo'],
      metrics: { revenue: '$5M+', conversion: '3.8%', aov: '$125' }
    },
    {
      id: 2,
      title: 'B2B Wholesale Portal',
      description: 'Custom B2B platform with bulk ordering, tiered pricing, and ERP integration.',
      image: 'https://images.unsplash.com/photo-1556740749-887f6717d7e4?w=800&h=600&fit=crop',
      tags: ['WooCommerce', 'SAP', 'Custom Portal', 'API Integration'],
      metrics: { orders: '10K+', clients: '500+', automation: '85%' }
    },
    {
      id: 3,
      title: 'Subscription Box Service',
      description: 'Full-stack subscription e-commerce with personalization engine.',
      image: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=800&h=600&fit=crop',
      tags: ['Custom Platform', 'Subscriptions', 'ML', 'Analytics'],
      metrics: { subscribers: '25K+', retention: '78%', ltv: '$450' }
    }
  ],
  'AI & ML Solutions': [
    {
      id: 1,
      title: 'Predictive Maintenance System',
      description: 'AI-powered system predicting equipment failures with 95% accuracy.',
      image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=600&fit=crop',
      tags: ['TensorFlow', 'IoT', 'Time Series', 'Python'],
      metrics: { accuracy: '95%', savings: '$2M+', downtime: '-60%' }
    },
    {
      id: 2,
      title: 'Customer Sentiment Analysis',
      description: 'NLP-based sentiment analyzer processing 100K+ customer reviews daily.',
      image: 'https://images.unsplash.com/photo-1639762681057-408e52192e55?w=800&h=600&fit=crop',
      tags: ['NLP', 'BERT', 'Real-time', 'API'],
      metrics: { reviews: '100K/day', accuracy: '92%', insights: 'Real-time' }
    },
    {
      id: 3,
      title: 'Computer Vision Quality Control',
      description: 'Automated visual inspection system for manufacturing defect detection.',
      image: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=800&h=600&fit=crop',
      tags: ['Computer Vision', 'PyTorch', 'Edge Computing'],
      metrics: { detection: '99.2%', speed: '100/min', defects: '-70%' }
    }
  ],
  'Data Analytics': [
    {
      id: 1,
      title: 'Retail Analytics Platform',
      description: 'Real-time analytics dashboard providing actionable insights for 200+ stores.',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop',
      tags: ['Power BI', 'Azure', 'ETL', 'Predictive Analytics'],
      metrics: { stores: '200+', dataPoints: '10M/day', insights: 'Real-time' }
    },
    {
      id: 2,
      title: 'Marketing Attribution Model',
      description: 'Multi-touch attribution system optimizing $5M+ annual ad spend.',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop',
      tags: ['Python', 'SQL', 'Tableau', 'Machine Learning'],
      metrics: { adSpend: '$5M+', roi: '+45%', accuracy: '88%' }
    },
    {
      id: 3,
      title: 'Healthcare Data Warehouse',
      description: 'HIPAA-compliant data warehouse integrating multiple hospital systems.',
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop',
      tags: ['Snowflake', 'dbt', 'HIPAA', 'ETL'],
      metrics: { records: '5M+', systems: '12', reports: '500+' }
    }
  ],
  'Cloud Solutions': [
    {
      id: 1,
      title: 'Multi-Cloud Migration',
      description: 'Seamless migration of enterprise workloads to hybrid cloud infrastructure.',
      image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=600&fit=crop',
      tags: ['AWS', 'Azure', 'Kubernetes', 'Terraform'],
      metrics: { cost: '-40%', performance: '+60%', downtime: '0 hours' }
    },
    {
      id: 2,
      title: 'Serverless Microservices',
      description: 'Event-driven architecture handling 1M+ requests daily with auto-scaling.',
      image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=600&fit=crop',
      tags: ['Lambda', 'API Gateway', 'DynamoDB', 'CloudWatch'],
      metrics: { requests: '1M+/day', latency: '<100ms', cost: '$500/month' }
    },
    {
      id: 3,
      title: 'DevOps Pipeline Automation',
      description: 'CI/CD pipeline reducing deployment time from hours to minutes.',
      image: 'https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?w=800&h=600&fit=crop',
      tags: ['Jenkins', 'Docker', 'GitLab', 'Ansible'],
      metrics: { deployments: '50/day', time: '-85%', rollback: '<5 mins' }
    }
  ],
  'Blockchain Development': [
    {
      id: 1,
      title: 'NFT Marketplace Platform',
      description: 'Decentralized marketplace for digital art with gas-optimized smart contracts.',
      image: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=800&h=600&fit=crop',
      tags: ['Solidity', 'Ethereum', 'IPFS', 'Web3.js'],
      metrics: { nfts: '10K+', volume: '$2M+', gas: '-35%' }
    },
    {
      id: 2,
      title: 'DeFi Lending Protocol',
      description: 'Decentralized lending platform with automated liquidity management.',
      image: 'https://images.unsplash.com/photo-1621761191319-c6fb62004040?w=800&h=600&fit=crop',
      tags: ['Smart Contracts', 'Polygon', 'Chainlink', 'DeFi'],
      metrics: { tvl: '$10M+', apy: '8-15%', users: '5K+' }
    },
    {
      id: 3,
      title: 'Supply Chain Tracking',
      description: 'Blockchain-based supply chain solution ensuring product authenticity.',
      image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&h=600&fit=crop',
      tags: ['Hyperledger', 'Enterprise', 'IoT', 'Traceability'],
      metrics: { products: '100K+', partners: '50+', trust: '99%' }
    }
  ],
  'Creative Copywriting': [
    {
      id: 1,
      title: 'Tech Startup Brand Voice',
      description: 'Complete brand messaging framework driving Series A funding success.',
      image: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?w=800&h=600&fit=crop',
      tags: ['Brand Voice', 'Messaging', 'Content Strategy', 'Website Copy'],
      metrics: { funding: '$5M', brand: 'Established', engagement: '+120%' }
    },
    {
      id: 2,
      title: 'E-Commerce Product Descriptions',
      description: 'SEO-optimized product copy increasing organic traffic by 180%.',
      image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800&h=600&fit=crop',
      tags: ['SEO Copy', 'Product Descriptions', 'Conversion Copy'],
      metrics: { traffic: '+180%', conversion: '+25%', skus: '500+' }
    },
    {
      id: 3,
      title: 'SaaS Email Campaign',
      description: 'Drip campaign series achieving 45% open rate and 12% conversion.',
      image: 'https://images.unsplash.com/photo-1596526131083-e8c633c948d2?w=800&h=600&fit=crop',
      tags: ['Email Copy', 'Nurture Sequences', 'CTAs', 'A/B Testing'],
      metrics: { openRate: '45%', conversion: '12%', revenue: '$200K' }
    }
  ]
};

